import React from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function UrgencySection() {
  const {
    t
  } = useLanguage();
  const reasons = [t('urgency.r1'), t('urgency.r2'), t('urgency.r3'), t('urgency.r4')];
  return <section className="py-20 lg:py-28 bg-brand-cream" data-id="element-373">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-374">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-375">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-376">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-100 text-red-700 text-sm font-bold mb-6" data-id="element-377">
              <Clock className="w-4 h-4" data-id="element-378" />
              <span data-id="element-379">{t('urgency.badge')}</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-black mb-6 leading-tight" data-id="element-380">
              {t('urgency.title')}
            </h2>

            <p className="text-lg text-brand-text/80 mb-8" data-id="element-381">
              {t('urgency.desc')}
            </p>

            <ul className="space-y-4 mb-8" data-id="element-382">
              {reasons.map((reason, index) => <li key={index} className="flex items-start gap-3" data-id="element-383">
                  <AlertTriangle className="w-5 h-5 text-brand-gold flex-shrink-0 mt-1" data-id="element-384" />
                  <span className="text-lg text-brand-black font-medium" data-id="element-385">
                    {reason}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-brand-black text-white p-8 md:p-12 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-386">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-[40px] pointer-events-none" data-id="element-387"></div>

            <h3 className="text-2xl font-bold text-brand-gold mb-4" data-id="element-388">
              {t('urgency.limitTitle')}
            </h3>
            <p className="text-lg text-white/80 leading-relaxed mb-8" data-id="element-389">
              {t('urgency.limitDesc')}
            </p>
            <div className="bg-white/10 border border-white/20 p-6 rounded-xl text-center" data-id="element-390">
              <p className="font-bold text-xl text-white" data-id="element-391">
                {t('urgency.limitQuote')}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}